import { isStatusValid } from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'
import { CONSULTA_SEGUIMENTO_NAO_PARA_TODOS_VALIDATION_MESSAGE } from '@mchat-rf/consulta-seguimento/validator-consultaSeguimento'
import { SimNaoEnum } from 'components/form'
import { createValidator, ErrorObject, required } from 'util/validation'

import { ConsultaSeguimentoPergunta11Model } from './model-consultaSeguimentoPergunta11'
import {
  hasPergunta11ExemplosFalhouAnySim,
  hasPergunta11ExemplosPassouAnySim,
  isPergunta11ExemplosAllFilled,
  isPergunta11ExemplosAllNao,
} from './utils-consultaSeguimentoPergunta11'

export const validatorConsultaSeguimentoPergunta11 = createValidator<ConsultaSeguimentoPergunta11Model>(
  {
    resultado: required,
    status: isStatusValid,
    PERGUNTA_11_HEADER: required,
  },
  (values: ConsultaSeguimentoPergunta11Model, errors: ErrorObject<ConsultaSeguimentoPergunta11Model>) => {
    if (values?.PERGUNTA_11_HEADER === SimNaoEnum.NAO) {
      const isPerguntaExemplosAllNao = isPergunta11ExemplosAllNao(values?.PERGUNTA_11_EXEMPLOS)
      const isExemplosAllFilled = isPergunta11ExemplosAllFilled(values?.PERGUNTA_11_EXEMPLOS)

      if (!isExemplosAllFilled) {
        errors.PERGUNTA_11_EXEMPLOS = pergunta11ExemplosValidator(values.PERGUNTA_11_EXEMPLOS)
      }

      if (isPerguntaExemplosAllNao) {
        errors.PERGUNTA_11_EXEMPLOS = CONSULTA_SEGUIMENTO_NAO_PARA_TODOS_VALIDATION_MESSAGE
      }

      const hasPassouAnySim = hasPergunta11ExemplosPassouAnySim(values?.PERGUNTA_11_EXEMPLOS)
      const hasFalhouAnySim = hasPergunta11ExemplosFalhouAnySim(values?.PERGUNTA_11_EXEMPLOS)

      if (hasPassouAnySim && hasFalhouAnySim) {
        errors.PERGUNTA_11_FREQUENCIA = required(values?.PERGUNTA_11_FREQUENCIA)
      }
    }
    return errors
  }
)

const pergunta11ExemplosValidator = createValidator<ConsultaSeguimentoPergunta11Model['PERGUNTA_11_EXEMPLOS']>({
  FALHOU: createValidator<NonNullable<ConsultaSeguimentoPergunta11Model['PERGUNTA_11_EXEMPLOS']>['FALHOU']>({
    ESTA_SEMPRE_SORRINDO: required,
    SORRI_PARA_BRINQUEDO_OU_ATIVIDADE: required,
    SORRI_AO_ACASO_OU_SEM_MOTIVO: required,
  }),
  PASSOU: createValidator<NonNullable<ConsultaSeguimentoPergunta11Model['PERGUNTA_11_EXEMPLOS']>['PASSOU']>({
    SORRI_QUANDO_VOCE_SORRI: required,
    SORRI_QUANDO_VOCE_ENTRA_NO_QUARTO: required,
    SORRI_QUANDO_VOCE_VOLTA: required,
  }),
})
